import { httpClient } from '../http';
import { State } from './types';

export const getStates = async (): Promise<State[]> => {
	const { data } = await httpClient.get<State[]>('/customers/states');

	return data;
};
